import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { IS_APP_CODEAC } from '../constants/env';
import Icon from './Icon';
import filterProps from '../utils/filterProps';
import { formatRepositoryUrl } from '../utils/repositoryNameAndOwner';
import { replaceAsciiCharWithSlash } from '../utils/resolveBranch';
import { DrawerItem } from './DrawerItem';
class RepositoryDetailDrawer extends Component {
    render() {
        const { vcsSlug, fullName, className, branch, t, isUserLoggedIn, ...rest } = filterProps(this.props, ['i18n', 'lng', 'tReady']);
        const name = formatRepositoryUrl(fullName);
        const encodedBranch = branch ? replaceAsciiCharWithSlash(branch) : '';
        const baseLink = `/${vcsSlug}/${name}${branch ? '/b-' + encodeURIComponent(encodedBranch) : ''}`;
        return (_jsxs("div", { ...rest, className: clsx('repository-detail__drawer', className), children: [isUserLoggedIn && _jsxs(NavLink, { to: "/", className: "repository-detail__drawer-link d-none d-md-block", children: [_jsx(Icon, { name: "angle-left", className: "mr-2" }), t('allRepositories')] }), _jsxs("ul", { className: "repository-detail__menu", children: [_jsx(DrawerItem, { linkTo: baseLink, linkText: t('dashboard'), iconName: "tachometer-alt", exact: true }), _jsx(DrawerItem, { linkTo: `${baseLink}/commits`, linkText: t('commits'), iconName: "code-merge" }), _jsx(DrawerItem, { linkTo: `/${vcsSlug}/${name}/pull-requests`, linkText: t('pullRequests'), iconName: "pull-request" }), IS_APP_CODEAC && isUserLoggedIn && (_jsx(DrawerItem, { linkTo: `/${vcsSlug}/${name}/settings`, linkText: t('settings.settings'), iconName: "cog" }))] })] }));
    }
}
RepositoryDetailDrawer.defaultProps = {
    className: '',
};
export default withTranslation()(RepositoryDetailDrawer);
